"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4057],{

/***/ 15071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37970);
/* harmony import */ var http__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(http__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94687);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(https__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8035);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(config__WEBPACK_IMPORTED_MODULE_2__);



var _config$get = config__WEBPACK_IMPORTED_MODULE_2___default().get('server.dataSource'),
  _config$get$host = _config$get.host,
  host = _config$get$host === void 0 ? '' : _config$get$host,
  maxSockets = _config$get.maxSockets,
  _config$get$keepAlive = _config$get.keepAlive,
  keepAlive = _config$get$keepAlive === void 0 ? true : _config$get$keepAlive;
var protocol = host.startsWith('https') ? (https__WEBPACK_IMPORTED_MODULE_1___default()) : (http__WEBPACK_IMPORTED_MODULE_0___default());
var options = {
  keepAlive: JSON.parse(keepAlive)
};
if (maxSockets) options.maxSockets = maxSockets;
var agent = new protocol.Agent(options);
var getServerFetchOptions = function getServerFetchOptions() {
  return {
    agent: agent
  };
};
/* harmony default export */ __webpack_exports__["Z"] = (getServerFetchOptions);

/***/ }),

/***/ 46371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ apolloClient; },
  "t": function() { return /* reexport */ middleware_getToken; }
});

// EXTERNAL MODULE: ../../node_modules/@apollo/client/index.js
var client = __webpack_require__(73059);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/core/index.js
var core = __webpack_require__(65040);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/createAuthLink.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

/* harmony default export */ var createAuthLink = (function (token) {
  return new client.ApolloLink(function () {
    var _ref = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(operation, forward) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (token) operation.setContext(function (_ref2) {
              var headers = _ref2.headers;
              return {
                headers: (0,esm_extends/* default */.Z)({}, headers, {
                  authorization: "Bearer ".concat(token)
                })
              };
            });
            return _context.abrupt("return", forward(operation));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
});
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/createLogLink.js
/* provided dependency */ var process = __webpack_require__(34406);


/* harmony default export */ var createLogLink = (function () {
  return new client.ApolloLink(function (operation, forward) {
    var startTime = new Date().getTime();
    return forward(operation).map(function (result) {
      if (process.env.DEBUG) {
        var operationType = operation.query.definitions[0].operation;
        var ellapsed = new Date().getTime() - startTime;
        var title = "%c[apollo log] ".concat(operationType, " ").concat(operation.operationName, " - (in ").concat(ellapsed, " ms)\n");
        if (esm/* whereAmI.onServer */.er.onServer) {
          console.log('\n\n ------------------------------------------------------------');
        }
        console.groupCollapsed(title, 'color: #bada55');
        console.log("\uD83C\uDF55 SEND", operation);
        console.log("\uD83C\uDF55 RESP", result);
        console.groupEnd(title);
      }
      return result;
    });
  });
});
// EXTERNAL MODULE: ../../node_modules/crypto-hash/browser.js
var browser = __webpack_require__(37503);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/persisted-queries/index.js
var persisted_queries = __webpack_require__(252);
;// CONCATENATED MODULE: ../graphql/build/esm/client/getFetchOptions.js

var getFetchOptions = function getFetchOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$browser = _ref.browser,
    browser = _ref$browser === void 0 ? esm/* whereAmI.onClient */.er.onClient : _ref$browser;
  if (browser) return {};
  var getServerFetchOptions = (__webpack_require__(15071)/* ["default"] */ .Z);
  return getServerFetchOptions();
};
/* harmony default export */ var client_getFetchOptions = (getFetchOptions);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/createHttpLink.js





var disableNextPersistedQueries = function disableNextPersistedQueries(logger) {
  return function (errorResponse) {
    var _errorResponse$graphQ;
    var isPersistedQueryNotSupported = !!(errorResponse == null ? void 0 : (_errorResponse$graphQ = errorResponse.graphQLErrors) == null ? void 0 : _errorResponse$graphQ.find(function (_ref) {
      var extensions = _ref.extensions;
      return (extensions == null ? void 0 : extensions.code) === 'PERSISTED_QUERY_NOT_SUPPORTED';
    }));
    logger.error('[ApolloClient] - Persisted Link Error:', errorResponse);
    return isPersistedQueryNotSupported;
  };
};
/* harmony default export */ var createHttpLink = (function (config) {
  var publicRuntimeConfig = config.publicRuntimeConfig,
    serverRuntimeConfig = config.serverRuntimeConfig;
  var runtimeConfig = esm/* whereAmI.onClient */.er.onClient ? publicRuntimeConfig : serverRuntimeConfig;
  var logger = (0,esm/* Logger */.Yd)(config);
  var _ref2 = (runtimeConfig == null ? void 0 : runtimeConfig.dataSource) || {},
    host = _ref2.host,
    _ref2$useAPQ = _ref2.useAPQ,
    useAPQ = _ref2$useAPQ === void 0 ? false : _ref2$useAPQ,
    _ref2$useGETForHashed = _ref2.useGETForHashedQueries,
    useGETForHashedQueries = _ref2$useGETForHashed === void 0 ? false : _ref2$useGETForHashed;
  var uri = "".concat(host, "/graphql");
  var httpLink = new core.HttpLink({
    credentials: esm/* whereAmI.onClient */.er.onClient ? 'include' : 'same-origin',
    fetch: fetch,
    fetchOptions: client_getFetchOptions({
      config: runtimeConfig
    }),
    uri: uri
  });
  if (useAPQ) {
    var persistedLink = (0,persisted_queries/* createPersistedQueryLink */.N)({
      disable: disableNextPersistedQueries(logger),
      sha256: browser/* sha256 */.JQ,
      useGETForHashedQueries: useGETForHashedQueries
    });
    return persistedLink.concat(httpLink);
  }
  return httpLink;
});
// EXTERNAL MODULE: ../../node_modules/@opentelemetry/api/build/esm/trace-api.js + 21 modules
var trace_api = __webpack_require__(94843);
// EXTERNAL MODULE: ../../node_modules/lodash/omitBy.js
var omitBy = __webpack_require__(99686);
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);
// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(16951);
var isNaN_default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(45455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(91478);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/createOnErrorLink.js







var handleTimeoutError = function handleTimeoutError(errorName, operation, response) {
  var span = trace_api/* trace.getActiveSpan */.g.getActiveSpan();
  var variables = omitBy_default()(operation == null ? void 0 : operation.variables, function (v) {
    return isNil_default()(v) || isNaN_default()(v) || isEmpty_default()(v);
  });
  span == null ? void 0 : span.addEvent(errorName, {
    'log.message': JSON.stringify(variables) || JSON.stringify(operation == null ? void 0 : operation.operationName),
    'log.severity': 'error'
  });
  if ((operation == null ? void 0 : operation.operationName) === 'suggestQuery' && (response == null ? void 0 : response.errors)) {
    response.errors = undefined;
  }
};
/* harmony default export */ var createOnErrorLink = (function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0,error/* onError */.q)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError,
      operation = _ref.operation,
      response = _ref.response;
    var logger = (0,esm/* Logger */.Yd)(config);
    (graphQLErrors || []).forEach(function (_ref2) {
      var message = _ref2.message,
        locations = _ref2.locations,
        path = _ref2.path,
        extensions = _ref2.extensions;
      if ((response == null ? void 0 : response.errors) && (operation == null ? void 0 : operation.operationName) !== 'root') {
        if (esm/* whereAmI.onClient */.er.onClient) {
          response.errors = [{
            extensions: extensions,
            message: message
          }];
        } else {
          response.errors = undefined;
        }
      }
      if ((extensions == null ? void 0 : extensions.reason) === 'request timed out' || (extensions == null ? void 0 : extensions.code) === 'REQUEST_TIMEOUT') {
        handleTimeoutError('mixer.graphql.federation.timeout', operation, response);
      } else {
        logger.error("[apolloClient] - GraphQl Error - message: ".concat(message, " - location: ").concat(JSON.stringify(locations), " - path: ").concat(path, " - variables: ").concat(JSON.stringify(operation == null ? void 0 : operation.variables), " - operation: ").concat(operation == null ? void 0 : operation.operationName));
      }
    });
    if (networkError == null ? void 0 : networkError.timeout) {
      handleTimeoutError('mixer.graphql.query.timeout', operation, response);
      logger.error("[ApolloClient] - Timeout error - variables: ".concat(JSON.stringify(operation == null ? void 0 : operation.variables), " - operation: ").concat(operation == null ? void 0 : operation.operationName));
    }
  });
});
// EXTERNAL MODULE: ../../node_modules/apollo-link-timeout/lib/timeoutLink.js
var lib_timeoutLink = __webpack_require__(30651);
var timeoutLink_default = /*#__PURE__*/__webpack_require__.n(lib_timeoutLink);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/concatTimeoutLink.js

/* harmony default export */ var concatTimeoutLink = (function (baseLink, timeout) {
  var timeoutLink = new (timeoutLink_default())(timeout);
  return timeoutLink.concat(baseLink);
});
// EXTERNAL MODULE: ../../node_modules/next/config.js
var next_config = __webpack_require__(70314);
var config_default = /*#__PURE__*/__webpack_require__.n(next_config);
// EXTERNAL MODULE: ../graphql/build/esm/query/login/LoginQuery.js
var LoginQuery = __webpack_require__(19934);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/getToken.js



function getToken_regeneratorRuntime() { "use strict"; getToken_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }




var auth = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(getToken_regeneratorRuntime().mark(function _callee(site, config) {
    var _LoginQuery$loc, _LoginQuery$loc$sourc, _data$login;
    var searchContextHost, graphQL, secrets, secret, query, fetchParams, response, _yield$response$json, data, errors;
    return getToken_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          searchContextHost = config.searchContext.host;
          graphQL = "".concat(searchContextHost, "/graphql");
          secrets = config.searchContext.secrets;
          secret = secrets[site] || secrets["default"];
          query = LoginQuery/* default */.Z == null ? void 0 : (_LoginQuery$loc = LoginQuery/* default.loc */.Z.loc) == null ? void 0 : (_LoginQuery$loc$sourc = _LoginQuery$loc.source) == null ? void 0 : _LoginQuery$loc$sourc.body;
          fetchParams = {
            body: JSON.stringify({
              operationName: 'login',
              query: query,
              variables: {
                secret: secret
              }
            }),
            headers: {
              'Content-Type': 'application/json'
            },
            method: 'POST',
            mode: 'cors'
          };
          _context.next = 8;
          return fetch(graphQL, (0,esm_extends/* default */.Z)({}, fetchParams, client_getFetchOptions()));
        case 8:
          response = _context.sent;
          if (response.ok) {
            _context.next = 11;
            break;
          }
          throw new Error("Authentication fail with status: ".concat(response.status, " ").concat(response.statusText, ", with secret: ").concat(secret));
        case 11:
          _context.next = 13;
          return response.json();
        case 13:
          _yield$response$json = _context.sent;
          data = _yield$response$json.data;
          errors = _yield$response$json.errors;
          if (!(errors && errors.length)) {
            _context.next = 18;
            break;
          }
          throw new Error("Authentication fail with status: ".concat(errors[0].message, ", with secret: ").concat(secret));
        case 18:
          return _context.abrupt("return", data == null ? void 0 : (_data$login = data.login) == null ? void 0 : _data$login.token);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function auth(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var dateAddMinutes = function dateAddMinutes(date) {
  var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  var now = date ? new Date(date) : new Date();
  now.setMinutes(now.getMinutes() + minutes);
  return new Date(now);
};
var tokenBySite = {};
var getSiteToken = function getSiteToken(site) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getTime();
  var siteToken = tokenBySite[site];
  if ((siteToken == null ? void 0 : siteToken.expiresIn) && siteToken.expiresIn > now) return siteToken;
  return undefined;
};
var setSiteToken = function setSiteToken(site, token) {
  var createdAt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().getTime();
  var _getConfig = config_default()(),
    serverRuntimeConfig = _getConfig.serverRuntimeConfig;
  var expiresIn = serverRuntimeConfig.searchContext.secretsExpiresIn;
  tokenBySite[site] = {
    expiresIn: dateAddMinutes(createdAt, expiresIn),
    token: token
  };
  return tokenBySite[site];
};
var getToken = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(getToken_regeneratorRuntime().mark(function _callee2() {
    var site,
      config,
      logger,
      siteToken,
      token,
      _args2 = arguments;
    return getToken_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          site = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'default';
          if (!esm/* whereAmI.onClient */.er.onClient) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", {});
        case 3:
          config = config_default()();
          logger = (0,esm/* Logger */.Yd)(config);
          _context2.prev = 5;
          siteToken = getSiteToken(site);
          if (!siteToken) {
            _context2.next = 9;
            break;
          }
          return _context2.abrupt("return", siteToken);
        case 9:
          _context2.next = 11;
          return auth(site, config.serverRuntimeConfig);
        case 11:
          token = _context2.sent;
          return _context2.abrupt("return", setSiteToken(site, token));
        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](5);
          logger.error("[Auth]:GetToken - Failed for site:".concat(site, " error:").concat(_context2.t0));
          return _context2.abrupt("return", {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[5, 15]]);
  }));
  return function getToken() {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ var middleware_getToken = (getToken);
;// CONCATENATED MODULE: ../graphql/build/esm/client/middleware/index.js






// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(71941);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/utilities/index.js + 19 modules
var utilities = __webpack_require__(46287);
;// CONCATENATED MODULE: ../graphql/build/esm/client/cachePolicies.js




var hashString = function hashString(str) {
  return crypto_browserify_default().createHash('sha256').update(str).digest('hex');
};
var cachePolicies = {
  Brand: {
    keyFields: ['slug']
  },
  Category: {
    fields: {
      meta: {
        merge: function merge(existing, incoming) {
          return (0,esm_extends/* default */.Z)({}, existing, incoming);
        }
      },
      subcategories: {
        merge: function merge(existing, incoming) {
          return (0,esm_extends/* default */.Z)({}, existing, incoming);
        }
      }
    },
    keyFields: function keyFields(object) {
      return (object == null ? void 0 : object.subcategories) ? "".concat(object.id, ":Sub") : "".concat(object.id, ":NoSub");
    }
  },
  FilterValueResponse: {
    keyFields: function keyFields(object) {
      return object.type ? ['slug', 'id', 'type'] : ['slug', 'id'];
    }
  },
  ListConversations: {
    fields: {
      listConversations: (0,utilities/* offsetLimitPagination */.CV)()
    }
  },
  Product: {
    fields: {
      seller: {
        details: {
          address: {
            merge: function merge(existing, incoming) {
              return (0,esm_extends/* default */.Z)({}, existing, incoming);
            }
          }
        },
        tags: {
          keyFields: ['message', 'type']
        }
      }
    },
    keyFields: function keyFields(object) {
      var _object$ads$id, _object$ads;
      return "".concat(object.variationId, ":").concat(object.id, ":").concat((_object$ads$id = object == null ? void 0 : (_object$ads = object.ads) == null ? void 0 : _object$ads.id) !== null && _object$ads$id !== void 0 ? _object$ads$id : '');
    }
  },
  Query: {
    fields: {
      recommendation: {
        merge: function merge(existing, incoming) {
          return (0,esm_extends/* default */.Z)({}, existing, incoming);
        }
      }
    }
  },
  Recommendation: {
    keyFields: function keyFields(_ref) {
      var id = _ref.id,
        title = _ref.title,
        designTokenId = _ref.designTokenId,
        products = _ref.products;
      var productIds = (products == null ? void 0 : products.map(function (p) {
        return p.id;
      }).join('_')) || 'no-products';
      var designToken = (designTokenId == null ? void 0 : designTokenId.split('.')[1]) || 'no-design-token-id';
      var baseString = "".concat((0,esm/* slug */.oF)(title), ":").concat(designToken, ":").concat(productIds);
      return "".concat(id, ":").concat(hashString(baseString));
    }
  },
  Seller: {
    keyFields: function keyFields(object) {
      var _object$tags, _object$tags$find;
      return "".concat(object.id, ":").concat((object == null ? void 0 : (_object$tags = object.tags) == null ? void 0 : (_object$tags$find = _object$tags.find(function (tag) {
        return !!tag.code;
      })) == null ? void 0 : _object$tags$find.code) || null);
    }
  },
  Variation: {
    keyFields: function keyFields(object) {
      return "".concat(object.id, ":").concat(object.type);
    }
  }
};
/* harmony default export */ var client_cachePolicies = (cachePolicies);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
;// CONCATENATED MODULE: ../graphql/build/esm/client/localTypeDefs.js

var _templateObject;

var localTypeDefs = (0,core.gql)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  type EstimateResponse\n  extend type ShippingResponse {\n    id: ID!\n    createdAt: String\n    expiresAt: String\n    shippingAddress: ShippingAddress\n    deliveries: [Delivery]\n    status: String!\n  }\n\n  type ShippingAddress {\n    zipCode: String\n    prefixZipCode: String\n    street: String\n    district: String\n    city: String\n    state: String\n    latitude: String\n    longitude: String\n    ibge: String\n  }\n\n  type Delivery {\n    id: String\n    status: DeliveryStatus\n    provider: DeliveryProvider\n    items: [DeliveryItem]\n    modalities: [DeliveryModality]\n  }\n\n  type DeliveryStatus {\n    code: String\n    message: String\n  }\n\n  type DeliveryProvider {\n    id: String\n  }\n\n  type DeliveryItem {\n    seller: DeliveryItemSeller\n    quantity: Int\n    type: String\n    bundleComposition: [DeliveryItemBundleComposition]\n    gifts: [DeliveryItemGift]\n  }\n\n  type DeliveryItemSeller {\n    id: String\n    name: String\n    sku: String\n  }\n\n  type DeliveryItemBundleComposition {\n    sku: String\n    quantity: String\n  }\n\n  type DeliveryItemGift {\n    sku: String\n    quantity: String\n  }\n\n  type DeliveryModality {\n    id: String\n    type: String\n    name: String\n    serviceProviders: [String]\n    shippingTime: DeliveryModalityShippingTime\n    campaigns: [DeliveryModalityCampaign]\n    cost: DeliveryModalityCost\n    zipCodeRestriction: Boolean\n  }\n\n  type DeliveryModalityShippingTime {\n    unit: String\n    value: DeliveryModalityShippingTimeValue\n    description: String\n    disclaimers: [DeliveryModalityDisclaimer]\n  }\n\n  type DeliveryModalityShippingTimeValue {\n    min: Int\n    max: Int\n  }\n\n  type DeliveryModalityDisclaimer {\n    sequence: Int\n    message: String\n  }\n\n  type DeliveryModalityCampaign {\n    id: String\n    name: String\n    skus: [String]\n  }\n\n  type DeliveryModalityCost {\n    customer: Int\n    operation: Int\n  }\n"])));
/* harmony default export */ var client_localTypeDefs = (localTypeDefs);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(9249);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(11987);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(95058);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(45754);
;// CONCATENATED MODULE: ../graphql/build/esm/client/voidCache.js







function voidCache_regeneratorRuntime() { "use strict"; voidCache_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = (0,getPrototypeOf/* default */.Z)(o), (0,possibleConstructorReturn/* default */.Z)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0,getPrototypeOf/* default */.Z)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

var VoidCache = function (_ApolloCache) {
  function VoidCache() {
    (0,classCallCheck/* default */.Z)(this, VoidCache);
    return _callSuper(this, VoidCache, arguments);
  }
  (0,inherits/* default */.Z)(VoidCache, _ApolloCache);
  return (0,createClass/* default */.Z)(VoidCache, [{
    key: "read",
    value: function read(_options) {
      return null;
    }
  }, {
    key: "write",
    value: function write(_options) {
      return undefined;
    }
  }, {
    key: "diff",
    value: function diff(_options) {
      return {};
    }
  }, {
    key: "watch",
    value: function watch(_options) {
      return function () {
        return undefined;
      };
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = (0,asyncToGenerator/* default */.Z)(voidCache_regeneratorRuntime().mark(function _callee() {
        return voidCache_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", undefined);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "evict",
    value: function evict(_options) {
      return false;
    }
  }, {
    key: "restore",
    value: function restore(_options) {
      return this;
    }
  }, {
    key: "extract",
    value: function extract(_options) {
      return {};
    }
  }, {
    key: "removeOptimistic",
    value: function removeOptimistic(_options) {
      return undefined;
    }
  }, {
    key: "batch",
    value: function batch(_options) {
      return undefined;
    }
  }, {
    key: "performTransaction",
    value: function performTransaction(_update, _optimisticId) {
      return undefined;
    }
  }, {
    key: "transformDocument",
    value: function transformDocument(document) {
      return document;
    }
  }, {
    key: "transformForLink",
    value: function transformForLink(document) {
      return document;
    }
  }, {
    key: "identify",
    value: function identify(_options) {
      return undefined;
    }
  }, {
    key: "gc",
    value: function gc() {
      return [];
    }
  }, {
    key: "modify",
    value: function modify(_options) {
      return false;
    }
  }]);
}(core.ApolloCache);
/* harmony default export */ var voidCache = (VoidCache);
;// CONCATENATED MODULE: ../graphql/build/esm/client/apolloClient.js






var serverFetchPolicy = {
  errorPolicy: 'all',
  fetchPolicy: 'no-cache'
};
var serverDefaultOptions = {
  mutate: serverFetchPolicy,
  query: serverFetchPolicy,
  watchQuery: serverFetchPolicy
};
var cachedApollo;
function apolloClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    token = _ref.token;
  var newApollo = function newApollo() {
    var _publicRuntimeConfig$, _serverRuntimeConfig$;
    var publicRuntimeConfig = config.publicRuntimeConfig,
      serverRuntimeConfig = config.serverRuntimeConfig;
    var dataSourceTimeout = esm/* whereAmI.onClient */.er.onClient ? publicRuntimeConfig == null ? void 0 : (_publicRuntimeConfig$ = publicRuntimeConfig.dataSource) == null ? void 0 : _publicRuntimeConfig$.timeout : serverRuntimeConfig == null ? void 0 : (_serverRuntimeConfig$ = serverRuntimeConfig.dataSource) == null ? void 0 : _serverRuntimeConfig$.timeout;
    var timeout = "".concat(dataSourceTimeout);
    var httpLink = createHttpLink(config);
    var timeoutLink = concatTimeoutLink(httpLink, timeout);
    var link = client.ApolloLink.from([createAuthLink(token), createOnErrorLink(config), createLogLink(), timeoutLink]);
    var CacheTool = esm/* whereAmI.onClient */.er.onClient ? core.InMemoryCache : voidCache;
    var cache = new CacheTool({
      typePolicies: client_cachePolicies
    }).restore(initialState);
    return new core.ApolloClient({
      cache: cache,
      connectToDevTools: esm/* whereAmI.onClient */.er.onClient && (publicRuntimeConfig == null ? void 0 : publicRuntimeConfig.environment) !== 'production',
      defaultOptions: esm/* whereAmI.onServer */.er.onServer ? serverDefaultOptions : {},
      link: link,
      ssrMode: esm/* whereAmI.onServer */.er.onServer,
      typeDefs: client_localTypeDefs
    });
  };
  var apollo = cachedApollo || newApollo();
  if (esm/* whereAmI.onClient */.er.onClient && !cachedApollo) cachedApollo = apollo;
  return apollo;
}
;// CONCATENATED MODULE: ../graphql/build/esm/client/index.js



/***/ }),

/***/ 26772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RY": function() { return /* reexport */ ClientContext; },
  "de": function() { return /* reexport */ ClientProvider; },
  "zt": function() { return /* reexport */ Provider; },
  "TN": function() { return /* reexport */ WishlistProvider; },
  "m8": function() { return /* reexport */ context_useClient; },
  "KZ": function() { return /* reexport */ useWishlistProvider; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../graphql/build/esm/client/index.js + 12 modules
var client = __webpack_require__(46371);
;// CONCATENATED MODULE: ../graphql/build/esm/context/Context.js


var ClientContext = (0,react.createContext)();
var Provider = ClientContext.Provider;

var ClientProvider = function ClientProvider(_ref) {
  var children = _ref.children,
    config = _ref.config,
    cookies = _ref.cookies,
    token = _ref.token;
  var memoizedClient = react.useMemo(function () {
    return (0,client/* client */.L)({
      config: config,
      cookies: cookies,
      token: token
    });
  }, [JSON.stringify(config), token]);
  return react.createElement(Provider, {
    value: memoizedClient
  }, children);
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../graphql/build/esm/hooks/index.js + 17 modules
var hooks = __webpack_require__(76297);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../graphql/build/esm/context/WishlistProvider.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var EMPTY_ID_ERROR_MSG = 'Empty userId';
var Context = (0,react.createContext)({});
var WishlistProvider = function WishlistProvider(_ref) {
  var children = _ref.children,
    values = _ref.values;
  var userId = values.userId;
  var hashId = userId == null ? void 0 : userId.slice(-4);
  var storage = (0,esm/* useStorage */.y$)('wishlist', hashId);
  var _useWishlist = (0,hooks/* useWishlist */.Ei)(),
    getWishlist = _useWishlist.getWishlist,
    useAddToWishlist = _useWishlist.addToWishlist,
    useRemoveFromWishlist = _useWishlist.removeFromWishlist;
  var checkUserId = function checkUserId() {
    var _storage$get;
    var storedId = (_storage$get = storage.get()) == null ? void 0 : _storage$get.id;
    return storage.exists() && storedId && hashId && storedId === hashId;
  };
  var updateWishlist = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _yield$getWishlist, data, error, _data$wishlist, remoteWishlist;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (userId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!(!checkUserId() || (0,esm/* checkExpireIn */.k$)(storage.get()))) {
              _context.next = 13;
              break;
            }
            _context.next = 5;
            return getWishlist(userId);
          case 5:
            _yield$getWishlist = _context.sent;
            data = _yield$getWishlist.data;
            error = _yield$getWishlist.error;
            if (!(!error && data)) {
              _context.next = 12;
              break;
            }
            remoteWishlist = data == null ? void 0 : (_data$wishlist = data.wishlist) == null ? void 0 : _data$wishlist.items;
            storage.set(remoteWishlist);
            return _context.abrupt("return", {
              items: remoteWishlist
            });
          case 12:
            return _context.abrupt("return", {
              error: error
            });
          case 13:
            return _context.abrupt("return", {
              items: storage.get().items
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function updateWishlist() {
      return _ref2.apply(this, arguments);
    };
  }();
  var addToWishlist = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2(args) {
      var _yield$useAddToWishli, data, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (userId) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!checkUserId()) {
              updateWishlist();
            }
            _context2.next = 5;
            return useAddToWishlist((0,esm_extends/* default */.Z)({}, args, {
              userId: userId
            }));
          case 5:
            _yield$useAddToWishli = _context2.sent;
            data = _yield$useAddToWishli.data;
            error = _yield$useAddToWishli.error;
            if (error) {
              _context2.next = 11;
              break;
            }
            storage.append({
              id: args.variationId,
              name: args.name,
              price: args.price
            });
            return _context2.abrupt("return", {
              data: data
            });
          case 11:
            return _context2.abrupt("return", (0,esm_extends/* default */.Z)({}, args, {
              error: error
            }));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function addToWishlist(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var removeFromWishlist = function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3(args) {
      var _yield$useRemoveFromW, data, error;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (userId) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!checkUserId()) {
              updateWishlist();
            }
            _context3.next = 5;
            return useRemoveFromWishlist((0,esm_extends/* default */.Z)({}, args, {
              userId: userId
            }));
          case 5:
            _yield$useRemoveFromW = _context3.sent;
            data = _yield$useRemoveFromW.data;
            error = _yield$useRemoveFromW.error;
            if (error) {
              _context3.next = 11;
              break;
            }
            storage.remove(args.variationId);
            return _context3.abrupt("return", {
              data: data
            });
          case 11:
            return _context3.abrupt("return", (0,esm_extends/* default */.Z)({}, args, {
              error: error
            }));
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function removeFromWishlist(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var isOnWishlist = function isOnWishlist(variationId) {
    var _storage$get2, _storage$get2$items;
    return Boolean((_storage$get2 = storage.get()) == null ? void 0 : (_storage$get2$items = _storage$get2.items) == null ? void 0 : _storage$get2$items.find(function (item) {
      return item.id === variationId;
    }));
  };
  return react.createElement(Context.Provider, {
    value: {
      addToWishlist: addToWishlist,
      checkUserId: checkUserId,
      isOnWishlist: isOnWishlist,
      removeFromWishlist: removeFromWishlist,
      updateWishlist: updateWishlist
    }
  }, children);
};
var useWishlistProvider = function useWishlistProvider() {
  return (0,react.useContext)(Context);
};
;// CONCATENATED MODULE: ../graphql/build/esm/context/useClient.js


var useClient = function useClient() {
  return (0,react.useContext)(ClientContext);
};
/* harmony default export */ var context_useClient = (useClient);
;// CONCATENATED MODULE: ../graphql/build/esm/context/index.js




/***/ }),

/***/ 59271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ge": function() { return /* reexport */ bloglinkList_BlogLinkList; },
  "wc": function() { return /* reexport */ blogPost_BlogPost; },
  "Cn": function() { return /* reexport */ blogRecommendation_BlogRecommendations; },
  "QM": function() { return /* reexport */ blogSeo_BlogSeo; },
  "$v": function() { return /* reexport */ blogTag_BlogTag; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/src/index.js
var src = __webpack_require__(30382);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogPost/BlogPost.js

var _templateObject;

var BlogPost = src_default()(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment posts on PostItem {\n    id\n    title\n    subtitle\n    slug\n    publishedAt\n    updatedAt\n    categoryId\n    categorySlug\n    categoryTitle\n    category {\n      id\n      title\n      categoryId\n    }\n    subcategory {\n      id\n      title\n      categoryId\n      slug\n    }\n    image {\n      alt\n      urls {\n        default\n        thumbnail\n        small\n        medium\n        large\n      }\n    }\n  }\n"])));
/* harmony default export */ var blogPost_BlogPost = (BlogPost);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogPost/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogRecommendation/BlogRecommendations.js

var BlogRecommendations_templateObject;


var BlogRecommendations = src_default()(BlogRecommendations_templateObject || (BlogRecommendations_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment recommendations on BlogRecommendation {\n    id\n    title\n    variation\n    categoryId\n    postIds\n    link\n    quantity\n    blogCategoryId\n    parentCategoryId\n    theme {\n      background\n      card\n    }\n    posts {\n      ...posts\n    }\n  }\n  ", "\n"])), blogPost_BlogPost);
/* harmony default export */ var blogRecommendation_BlogRecommendations = (BlogRecommendations);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogRecommendation/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogSeo/BlogSeo.js

var BlogSeo_templateObject;

var BlogSeo = src_default()(BlogSeo_templateObject || (BlogSeo_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment seo on ComponentBlogSeo {\n    title\n    description\n  }\n"])));
/* harmony default export */ var blogSeo_BlogSeo = (BlogSeo);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogSeo/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogTag/BlogTag.js

var BlogTag_templateObject;

var BlogTag = src_default()(BlogTag_templateObject || (BlogTag_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment tags on PostTag {\n    id\n    title\n    slug\n  }\n"])));
/* harmony default export */ var blogTag_BlogTag = (BlogTag);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogTag/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/bloglinkList/BlogLinkList.js

var BlogLinkList_templateObject;

var BlogLinkList = src_default()(BlogLinkList_templateObject || (BlogLinkList_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment linkList on ComponentPresentationLinkList {\n    href\n    value\n    alt\n  }\n"])));
/* harmony default export */ var bloglinkList_BlogLinkList = (BlogLinkList);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/bloglinkList/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/index.js






/***/ }),

/***/ 48248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_Z": function() { return /* reexport */ ChatMessageError; },
  "Hc": function() { return /* reexport */ chatFragments_ChatMessage; }
});

// UNUSED EXPORTS: LinkListFragment, PostFragment, RecommendationsFragment, SeoFragment, TagFragment

// EXTERNAL MODULE: ../graphql/build/esm/fragments/blogFragments/index.js + 10 modules
var blogFragments = __webpack_require__(59271);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/src/index.js
var src = __webpack_require__(30382);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/chatFragments/ChatMessage.js

var _templateObject, _templateObject2;

var ChatMessage = src_default()(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment chatMessage on ChatMessage {\n    id\n    fromUser {\n      id\n      fullName\n      refKey\n      type\n    }\n    toUser {\n      id\n      fullName\n      refKey\n      type\n    }\n    content\n    readBy\n    moderation {\n      status\n      whenAt\n    }\n    customFields {\n      name\n      value\n    }\n    whenAt\n  }\n"])));
var ChatMessageError = src_default()(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment chatMessageError on ChatErrorResponse {\n    message\n    slug\n    stack\n    detail {\n      loc\n      msg\n    }\n  }\n"])));
/* harmony default export */ var chatFragments_ChatMessage = (ChatMessage);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/chatFragments/index.js


;// CONCATENATED MODULE: ../graphql/build/esm/fragments/index.js



/***/ }),

/***/ 88684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ itemFragments_ItemFragment; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/src/index.js
var src = __webpack_require__(30382);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/itemFragments/ItemFragment.js

var _templateObject;

var ItemFragment = src_default()(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment ItemFragment on Item {\n    id\n    partNumber\n    title\n    description\n    reference\n    available\n    type\n  }\n"])));
/* harmony default export */ var itemFragments_ItemFragment = (ItemFragment);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/itemFragments/index.js


/***/ })

}]);